'use strict';

var offset = require('./offset'),
    getWindow = require('./isWindow');

module.exports = function height(node, client) {
  var win = getWindow(node);
  return win ? win.innerHeight : client ? node.clientHeight : offset(node).height;
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/dom-helpers/query/height.js
 ** module id = 131
 ** module chunks = 0
 **/